import { render } from "./Cluster.vue?vue&type=template&id=032af9c2&ts=true"
import script from "./Cluster.vue?vue&type=script&lang=ts"
export * from "./Cluster.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__